import { render, staticRenderFns } from "./FlagDe.vue?vue&type=template&id=4574c62a&"
import script from "./FlagDe.vue?vue&type=script&lang=js&"
export * from "./FlagDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports